<template>
  <div class="pay-system">
    <div
      class="pay-system__icon"
      v-if="paySystemIcon"
      v-html="paySystemIcon"
    ></div>
    <div class="pay-system__text">
      {{ paySystem }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    paySystem: {
      type: String,
      default: null,
    },
  },
  name: 'TransactionPaySystem',
  PAY_SYSTEM_ICONS: {
    mastercard: `<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.35193 0.641602H3.64807V5.35827H6.35193V0.641602Z" fill="#F26522"/><path d="M3.81974 3C3.81974 2.04167 4.28326 1.19167 4.99571 0.641667C4.4721 0.241667 3.81116 0 3.09013 0C1.38197 0 0 1.34167 0 3C0 4.65833 1.38197 6 3.09013 6C3.81116 6 4.4721 5.75833 4.99571 5.35833C4.28326 4.80833 3.81974 3.95833 3.81974 3Z" fill="#E51B24"/><path d="M9.99998 3C9.99998 4.65833 8.61801 6 6.90985 6C6.18882 6 5.52788 5.75833 5.00427 5.35833C5.7253 4.80833 6.18024 3.95833 6.18024 3C6.18024 2.04167 5.71672 1.19167 5.00427 0.641667C5.52788 0.241667 6.18882 0 6.90985 0C8.61801 0 9.99998 1.34167 9.99998 3Z" fill="#F99F1C"/></svg>`,
    visa: `<svg width="10" height="3" viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_1384)"><path d="M3.79688 0.0532172L2.4875 2.95452H1.63333L0.989062 0.639091C0.95 0.496372 0.916146 0.444122 0.796875 0.384132C0.602604 0.286405 0.281771 0.194485 0 0.137397L0.0192708 0.0532172H1.39427C1.56927 0.0532172 1.72708 0.161587 1.76667 0.349299L2.10677 2.02806L2.94792 0.0532172H3.79688ZM7.14375 2.00726C7.1474 1.24141 6.00365 1.19932 6.01146 0.857281C6.01406 0.753266 6.12083 0.642477 6.35417 0.614417C6.46979 0.600387 6.78906 0.589744 7.15104 0.744074L7.29271 0.128689C7.09844 0.0628931 6.84844 0 6.53698 0C5.73802 0 5.17604 0.394291 5.17135 0.959361C5.16615 1.37687 5.5724 1.61006 5.87865 1.74891C6.19375 1.89115 6.29948 1.98258 6.29792 2.10934C6.29583 2.30382 6.04688 2.38994 5.81406 2.39332C5.40781 2.39913 5.1724 2.29124 4.98438 2.20997L4.83802 2.84567C5.02656 2.92598 5.37552 2.99613 5.73646 3C6.58594 3 7.14115 2.61055 7.14375 2.00726ZM9.2526 2.95452H10L9.3474 0.0532172H8.65781C8.5026 0.0532172 8.37188 0.136913 8.31406 0.266086L7.10156 2.95452H7.95L8.11875 2.52104H9.15521L9.2526 2.95452ZM8.35104 1.92646L8.77656 0.836962L9.02135 1.92646H8.35104ZM4.95156 0.0532172L4.28333 2.95452H3.475L4.14375 0.0532172H4.95156Z" fill="#1434CB"/></g><defs><clipPath id="clip0_1_1384"><rect width="10" height="3" fill="white"/></clipPath></defs></svg>`,
  },
  computed: {
    paySystemIcon() {
      return (
        this.$options.PAY_SYSTEM_ICONS[
          this.paySystem.replaceAll(' ', '').toLowerCase()
        ] || null
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.pay-system {
  display: flex;
  align-items: center;
  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(97, 128, 199, 0.2);
    border-radius: 4px;
    margin-right: 7px;

    svg {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__text {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #1a1f29;
    opacity: 0.7;
  }
}
</style>
